import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export function Field(props) {
    const { id, label, hint, error, required, describedBy, invalid, errorRole = 'alert', children, className } = props;
    const describedByIds = [describedBy ?? null, hint ? `${id}-hint` : null, error ? `${id}-err` : null]
        .filter(Boolean)
        .join(' ');
    const control = React.cloneElement(children, {
        id,
        'aria-describedby': describedByIds || undefined,
        'aria-invalid': error || invalid ? true : undefined,
        'aria-required': required || undefined,
    });
    return (_jsxs("div", { className: className, "data-field": true, children: [_jsxs("label", { htmlFor: id, style: {
                    display: 'block',
                    fontFamily: 'var(--font-ui)',
                    fontSize: 'var(--font-size-2xs)',
                    fontWeight: 500,
                    color: 'var(--text)',
                    marginBottom: 'var(--space-1)',
                }, children: [label, required ? (_jsx("span", { "aria-hidden": "true", style: { color: 'var(--danger-fg)', marginLeft: 4 }, children: "*" })) : null] }), control, hint ? (_jsx("p", { id: `${id}-hint`, style: {
                    margin: '4px 0 0',
                    color: 'var(--text-muted)',
                    fontSize: 'var(--font-size-3xs)',
                }, children: hint })) : null, error ? (_jsx("p", { id: `${id}-err`, role: errorRole === 'alert' ? 'alert' : undefined, style: {
                    margin: '4px 0 0',
                    color: 'var(--danger-fg)',
                    fontSize: 'var(--font-size-3xs)',
                    fontWeight: 500,
                }, children: error })) : null] }));
}
//# sourceMappingURL=Field.js.map